import {
  PAYMENT_INTERVAL,
  POTENTIAL_MERCHANT_LOSSES,
  THRESHOLD_BUSINESS_CONCEPTS,
  THRESHOLD_CATEGORIES,
} from '@/constants';

/** @param {string | number} returnRate */
export const getReturnRateValue = returnRate => {
  // returnRate is usually a string like this: "20.31%"
  // parse float can parse both `5%` and `5` to `5`
  const parsedReturnRate = parseFloat(returnRate);
  const invalidInput =
    !['string', 'number'].includes(typeof returnRate) || Number.isNaN(parsedReturnRate);

  if (invalidInput) return null;

  return parsedReturnRate / 100;
};

export const hasPMLCategoryOrBusinessConcept = (goodCategory, businessConcepts) =>
  !THRESHOLD_CATEGORIES.includes(goodCategory) &&
  !THRESHOLD_BUSINESS_CONCEPTS.some(businessConcept => businessConcepts.includes(businessConcept));

export const calculatePML = ({
  yearlyAcquiredVolume,
  paymentDelay,
  returnRate,
  OutstandingReturnsVariable,
}) => {
  const collateral = (yearlyAcquiredVolume / POTENTIAL_MERCHANT_LOSSES.YEAR_IN_DAYS) * paymentDelay;
  const returns =
    (yearlyAcquiredVolume / POTENTIAL_MERCHANT_LOSSES.YEAR_IN_DAYS) *
    POTENTIAL_MERCHANT_LOSSES.QUARTER_IN_DAYS *
    OutstandingReturnsVariable *
    returnRate;
  const pml = Math.ceil(returns - collateral);

  return Math.max(pml, 0);
};

export const hasHighPML = ({
  yearlyAcquiredVolume,
  paymentDelay,
  returnRate,
  OutstandingReturnsVariable,
}) => {
  const pml = calculatePML({
    yearlyAcquiredVolume,
    paymentDelay,
    returnRate,
    OutstandingReturnsVariable,
  });

  return pml > POTENTIAL_MERCHANT_LOSSES.MAX_THRESHOLDS;
};

export const calculateFinalPaymentDelay = (paymentDelay, paymentInterval) => {
  if (!paymentInterval) return 0;

  return paymentInterval === PAYMENT_INTERVAL.DAILY ? paymentDelay : paymentDelay * 7 + 3;
};
